import React, { useState } from 'react'
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  Alert,
  Link,
} from '@mui/material'
import { ArrowBack } from '@mui/icons-material'

export default function ForgotPassword({ flash = {} }) {
  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    setErrors({})

    if (!email) {
      setErrors({ email: 'E-Mail ist erforderlich' })
      return
    }

    setSubmitting(true)

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = '/password'

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    const fields = {
      authenticity_token: csrfToken || '',
      'user[email]': email,
    }

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h5" component="h1" fontWeight={700} gutterBottom>
          Passwort zurücksetzen
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
          Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen des Passworts.
        </Typography>

        {flash.alert && (
          <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
            {flash.alert}
          </Alert>
        )}
        {flash.notice && (
          <Alert severity="success" sx={{ width: '100%', mb: 2 }}>
            {flash.notice}
          </Alert>
        )}

        <Paper elevation={2} sx={{ p: 4, width: '100%' }}>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              label="E-Mail"
              type="email"
              fullWidth
              margin="normal"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={!!errors.email}
              helperText={errors.email}
              slotProps={{ htmlInput: { 'data-testid': 'email-input' } }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={submitting}
              sx={{ mt: 2, mb: 2 }}
              data-testid="send-reset-button"
            >
              {submitting ? 'Sende...' : 'Zurücksetzen-Link senden'}
            </Button>
          </Box>
        </Paper>

        <Box sx={{ mt: 2 }}>
          <Link href="/login" variant="body2" underline="hover" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <ArrowBack fontSize="small" />
            Zurück zur Anmeldung
          </Link>
        </Box>
      </Box>
    </Container>
  )
}
